import ApiController from './ApiController';
import PermissaoController from './PermissaoController';

class ClienteController {

    constructor() {
        this.apiController = new ApiController();
        this.permissaoController = new PermissaoController();
    }

    async listar(page, pageSize, { nome, cpf, inativos, avaliador }) {
        try {
            //Envia requisição para o servidor e captura os dados de resposta
            const { data: result } = await this.apiController.get('/cliente', { page, pageSize, nome, cpf, inativos, avaliador });
            //Marca que houve retorno com sucesso
            result.sucesso = true;
            return result;
        } catch (error) {
            //Captura o erro e retorna para a aplicação
            const erros = error.response ? error.response.data : [{ mensagem: error.message || 'Erro de conexão com o servidor' }];
            return { sucesso: false, erros };
        }
    }

    async obter(id) {
        //Verifica se o ID está preenchido
        if (!id)
            return { sucesso: false, erros: [{ campo: 'id', mensagem: 'É necessário' }] };

        try {
            //Envia requisição para o servidor e captura os dados de resposta
            const { data: result } = await this.apiController.get('/cliente/' + id.toString());
            //Marca que houve retorno com sucesso
            result.sucesso = true;
            return result;
        } catch (error) {
            //Captura o erro e retorna para a aplicação
            const erros = error.response ? error.response.data : [{ mensagem: error.message || 'Erro de conexão com o servidor' }];
            return { sucesso: false, erros };
        }
    }


    async salvar(cliente) {
        const erros = await this._validarCampos(cliente, false);

        //Retorna os erros para a aplicação
        if (erros.length > 0)
            return { sucesso: false, erros };

        try {
            //Monta o corpo da requisição
            const body = await this._extrairCampos(cliente);
            //Envia requisição para o servidor e captura os dados de resposta
            const { data: result } = await this.apiController.post('/cliente', body);
            //Marca que houve retorno com sucesso
            result.sucesso = true;
            return result;
        } catch (error) {
            //Captura o erro e retorna para a aplicação
            const erros = error.response ? error.response.data : [{ mensagem: error.message || 'Erro de conexão com o servidor' }];
            return { sucesso: false, erros };
        }
    }

    async atualizar(cliente) {
        const erros = await this._validarCampos(cliente, true);

        if (erros.length > 0)
            return { sucesso: false, erros };

        try {
            //Monta o corpo da requisição
            const body = await this._extrairCampos(cliente);
            //Envia requisição para o servidor e captura os dados de resposta
            const { data: result } = await this.apiController.put('/cliente/' + cliente.id.toString(), body);
            //Marca que houve retorno com sucesso
            result.sucesso = true;
            return result;
        } catch (error) {
            //Captura o erro e retorna para a aplicação
            const erros = error.response ? error.response.data : [{ mensagem: error.message || 'Erro de conexão com o servidor' }];
            return { sucesso: false, erros };
        }
    }

    async listarSelecao(empresa) {
        try {
            //Envia requisição para o servidor e captura os dados de resposta
            const { data: items } = await this.apiController.get('/cliente', { pagination: false, empresa });
            //Marca que houve retorno com sucesso
            const result = {
                sucesso: true,
                items
            };
            return result;
        } catch (error) {
            //Captura o erro e retorna para a aplicação
            const erros = error.response ? error.response.data : [{ mensagem: error.message || 'Erro de conexão com o servidor' }];
            return { sucesso: false, erros };
        }
    }

    async listarDisponiveis(page = 1, pageSize = 10, { nome, cpf, empresa } = {}) {
        try {
            //Envia requisição para o servidor e captura os dados de resposta
            const { data: result } = await this.apiController.get('/cliente/disponiveis', { pagination: true, page, pageSize, nome, cpf, empresa });
            //Marca que houve retorno com sucesso
            result.sucesso = true;
            return result;
        } catch (error) {
            //Captura o erro e retorna para a aplicação
            const erros = error.response ? error.response.data : [{ mensagem: error.message || 'Erro de conexão com o servidor' }];
            return { sucesso: false, erros };
        }
    }

    async _validarCampos(cliente, atualizacao) {
        var erros = [];

        //Verifica se a empresa está sendo preenchida
        if (!cliente) {
            erros.push({ campo: '', mensagem: 'Cliente é necessário' });
        } else {
            //Verifica se o id está preenchido
            if (atualizacao && !cliente.id)
                erros.push({ campo: 'id', mensagem: 'É necessário' });

            //Verifica se o nome está preenchido
            if (!cliente.nome)
                erros.push({ campo: 'nome', mensagem: 'É necessário' });

            //Verifica se o CPF está preenchido
            if (!cliente.cpf)
                erros.push({ campo: 'cpf', mensagem: 'É necessário' });

            //Verifica se a data de nascimento está preenchida
            if (!cliente.dataNascimento)
                erros.push({ campo: 'dataNascimento', mensagem: 'É necessário' });

            //Verifica se o email ou telefone do usuário estão preenchidos
            if (!cliente.email && !cliente.telefone) {
                erros.push({ campo: 'email', mensagem: 'É necessário' });
                erros.push({ campo: 'telefone', mensagem: 'É necessário' });
            }

            if (cliente.ativo === null || cliente.ativo === undefined) {
                erros.push({ campo: 'ativo', mensagem: 'É necessário' });
            }

            //Verifica se a senha está preenchida
            if (!atualizacao && !cliente.senha)
                erros.push({ campo: 'senha', mensagem: 'É necessário' });

            //Verifica se o id do gênero está preenchido
            if (!cliente.genero)
                erros.push({ campo: 'genero', mensagem: 'É necessário' });

            //Verifica se o id da empresa está preenchida
            if (await this.permissaoController.permiteSelecionarEmpresa()) {
                if (!cliente.empresa)
                    erros.push({ campo: 'empresa', mensagem: 'É necessário' });
            }
        }


        return erros;
    }

    async _extrairCampos(cliente) {
        const result = {
            nome: cliente.nome,
            cpf: cliente.cpf,
            genero: cliente.genero,
            dataNascimento: cliente.dataNascimento,
            ativo: !!cliente.ativo
        };

        if (cliente.senha)
            result.senha = cliente.senha;
        if (cliente.email)
            result.email = cliente.email;
        if (cliente.telefone)
            result.telefone = cliente.telefone;
        if (cliente.patologia)
            result.patologia = cliente.patologia;
        if (cliente.profissao)
            result.profissao = cliente.profissao;

        if (cliente.cep)
            result.cep = cliente.cep;
        if (cliente.logradouro)
            result.logradouro = cliente.logradouro;
        if (cliente.numero)
            result.numero = cliente.numero;
        if (cliente.complemento)
            result.complemento = cliente.complemento;
        if (cliente.bairro)
            result.bairro = cliente.bairro;
        if (cliente.municipio)
            result.municipio = cliente.municipio;
        if (cliente.uf)
            result.uf = cliente.uf;

        if (await this.permissaoController.permiteSelecionarEmpresa()) {
            if (cliente.empresa)
                result.empresa = cliente.empresa;
        }

        return result;
    }

}

export default ClienteController;